/*
 *
 * https://www.w3.org/Style/CSS/all-properties.en.html
 */

export const styleProperties = [
  'alignContent',
  'alignItems',
  'alignSelf',
  'alignmentAdjust',
  'alignmentBaseline',
  'all',
  'animation',
  'animationDelay',
  'animationDirection',
  'animationDuration',
  'animationFillMode',
  'animationIterationCount',
  'animationName',
  'animationPlayState',
  'animationTimingFunction',
  'appearance',
  'azimuth',
  'backfaceVisibility',
  'background',
  'backgroundAttachment',
  'backgroundBlendMode',
  'backgroundClip',
  'backgroundColor',
  'backgroundImage',
  'backgroundOrigin',
  'backgroundPosition',
  'backgroundRepeat',
  'backgroundSize',
  'baselineShift',
  'blockOverflow',
  'blockSize',
  'bookmarkLabel',
  'bookmarkLevel',
  'bookmarkState',
  'border',
  'borderBlock',
  'borderBlockColor',
  'borderBlockEnd',
  'borderBlockEndColor',
  'borderBlockEndStyle',
  'borderBlockEndWidth',
  'borderBlockStart',
  'borderBlockStartColor',
  'borderBlockStartStyle',
  'borderBlockStartWidth',
  'borderBlockStyle',
  'borderBlockWidth',
  'borderBottom',
  'borderBottomColor',
  'borderBottomFitLength',
  'borderBottomFitWidth',
  'borderBottomImage',
  'borderBottomLeftFitWidth',
  'borderBottomLeftImage',
  'borderBottomLeftRadius',
  'borderBottomRightFitLength',
  'borderBottomRightFitWidth',
  'borderBottomRightImage',
  'borderBottomRightRadius',
  'borderBottomStyle',
  'borderBottomWidth',
  'borderBottomlEftFitLength',
  'borderBoundary',
  'borderBreak',
  'borderCollapse',
  'borderColor',
  'borderCornerFit',
  'borderCornerImage',
  'borderCornerImageTransform',
  'borderEndEndRadius',
  'borderEndStartRadius',
  'borderFit',
  'borderFitLength',
  'borderFitWidth',
  'borderImage',
  'borderImageOutset',
  'borderImageRepeat',
  'borderImageSlice',
  'borderImageSource',
  'borderImageTransform',
  'borderImageWidth',
  'borderInline',
  'borderInlineColor',
  'borderInlineEnd',
  'borderInlineEndColor',
  'borderInlineEndStyle',
  'borderInlineEndWidth',
  'borderInlineStart',
  'borderInlineStartColor',
  'borderInlineStartStyle',
  'borderInlineStartWidth',
  'borderInlineStyle',
  'borderInlineWidth',
  'borderLeft',
  'borderLeftColor',
  'borderLeftFitLength',
  'borderLeftFitWidth',
  'borderLeftImage',
  'borderLeftStyle',
  'borderLeftWidth',
  'borderRadius',
  'borderRight',
  'borderRightColor',
  'borderRightFitLength',
  'borderRightFitWidth',
  'borderRightImage',
  'borderRightStyle',
  'borderRightWidth',
  'borderSpacing',
  'borderStartEndRadius',
  'borderStartStartRadius',
  'borderStyle',
  'borderTop',
  'borderTopColor',
  'borderTopFitLength',
  'borderTopFitWidth',
  'borderTopImage',
  'borderTopLeftFitLength',
  'borderTopLeftFitWidth',
  'borderTopLeftImage',
  'borderTopLeftRadius',
  'borderTopRightFitLength',
  'borderTopRightFitWidth',
  'borderTopRightImage',
  'borderTopRightRadius',
  'borderTopStyle',
  'borderTopWidth',
  'borderWidth',
  'bottom',
  'boxDecorationBreak',
  'boxShadow',
  'boxSizing',
  'boxSnap',
  'breakAfter',
  'breakBefore',
  'breakInside',
  'captionSide',
  'caret',
  'caretColor',
  'caretShape',
  'chains',
  'clear',
  'clip',
  'clipPath',
  'clipRule',
  'color',
  'colorAdjust',
  'colorInterpolationFilters',
  'colorScheme',
  'columnCount',
  'columnFill',
  'columnGap',
  'columnRule',
  'columnRuleColor',
  'columnRuleStyle',
  'columnRuleWidth',
  'columnSpan',
  'columnWidth',
  'columns',
  'contain',
  'content',
  'continue',
  'counterIncrement',
  'counterReset',
  'counterSet',
  'cue',
  'cueAfter',
  'cueBefore',
  'cursor',
  'direction',
  'display',
  'dominantBaseline',
  'dropInitialAfterAdjust',
  'dropInitialAfterAlign',
  'dropInitialBeforeAdjust',
  'dropInitialBeforeAlign',
  'dropInitialSize',
  'dropInitialValue',
  'elevation',
  'emptyCells',
  'filter',
  'flex',
  'flexBasis',
  'flexDirection',
  'flexFlow',
  'flexGrow',
  'flexShrink',
  'flexWrap',
  'float',
  'floodColor',
  'floodOpacity',
  'flow',
  'flowFrom',
  'flowInto',
  'font',
  'fontFamily',
  'fontFeatureSettings',
  'fontKerning',
  'fontLanguageOverride',
  'fontMaxSize',
  'fontMinSize',
  'fontOpticalSizing',
  'fontPalette',
  'fontSize',
  'fontSizeAdjust',
  'fontStretch',
  'fontStyle',
  'fontSynthesis',
  'fontSynthesisSmallCaps',
  'fontSynthesisStyle',
  'fontSynthesisWeight',
  'fontVariant',
  'fontVariantAlternates',
  'fontVariantCaps',
  'fontVariantEastAsian',
  'fontVariantEmoji',
  'fontVariantLigatures',
  'fontVariantNumeric',
  'fontVariantPosition',
  'fontVariationSettings',
  'fontWeight',
  'footnoteDisplay',
  'footnotePolicy',
  'forcedColorAdjust',
  'gap',
  'glyphOrientationVertical',
  'grid',
  'gridArea',
  'gridAutoColumns',
  'gridAutoFlow',
  'gridAutoRows',
  'gridColumn',
  'gridColumnEnd',
  'gridColumnStart',
  'gridRow',
  'gridRowEnd',
  'gridRowStart',
  'gridTemplate',
  'gridTemplateAreas',
  'gridTemplateColumns',
  'gridTemplateRows',
  'hangingPunctuation',
  'height',
  'hyphenateCharacter',
  'hyphenateLimitChars',
  'hyphenateLimitLast',
  'hyphenateLimitLines',
  'hyphenateLimitZone',
  'hyphens',
  'imageOrientation',
  'imageResolution',
  'initialLetters',
  'initialLettersAlign',
  'initialLettersWrap',
  'inlineBoxAlign',
  'inlineSize',
  'inlineSizing',
  'inset',
  'insetBlock',
  'insetBlockEnd',
  'insetBlockStart',
  'insetInline',
  'insetInlineEnd',
  'insetInlineStart',
  'isolation',
  'justifyContent',
  'justifyItems',
  'justifySelf',
  'left',
  'letterSpacing',
  'lightingColor',
  'lineBreak',
  'lineClamp',
  'lineGrid',
  'lineHeight',
  'linePadding',
  'lineSnap',
  'lineStacking',
  'lineStackingRuby',
  'lineStackingShift',
  'lineStackingStrategy',
  'listStyle',
  'listStyleImage',
  'listStylePosition',
  'listStyleType',
  'margin',
  'marginBlock',
  'marginBlockEnd',
  'marginBlockStart',
  'marginBottom',
  'marginInline',
  'marginInlineEnd',
  'marginInlineStart',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginTrim',
  'markerSide',
  'mask',
  'maskBorder',
  'maskBorderMode',
  'maskBorderOutset',
  'maskBorderRepeat',
  'maskBorderSlice',
  'maskBorderSource',
  'maskBorderWidth',
  'maskClip',
  'maskComposite',
  'maskImage',
  'maskMode',
  'maskOrigin',
  'maskPosition',
  'maskRepeat',
  'maskSize',
  'maskType',
  'maxBlockSize',
  'maxHeight',
  'maxInlineSize',
  'maxLines',
  'maxWidth',
  'minBlockSize',
  'minHeight',
  'minInlineSize',
  'minWidth',
  'mixBlendMode',
  'navDown',
  'navLeft',
  'navRight',
  'navUp',
  'objectFit',
  'objectPosition',
  'offset',
  'offsetAfter',
  'offsetAnchor',
  'offsetBefore',
  'offsetDistance',
  'offsetEnd',
  'offsetPath',
  'offsetPosition',
  'offsetRotate',
  'offsetStart',
  'opacity',
  'order',
  'orphans',
  'outline',
  'outlineColor',
  'outlineOffset',
  'outlineStyle',
  'outlineWidth',
  'overflow',
  'overflowBlock',
  'overflowInline',
  'overflowWrap',
  'overflowX',
  'overflowY',
  'padding',
  'paddingBlock',
  'paddingBlockEnd',
  'paddingBlockStart',
  'paddingBottom',
  'paddingInline',
  'paddingInlineEnd',
  'paddingInlineStart',
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'page',
  'pageBreakAfter',
  'pageBreakBefore',
  'pageBreakInside',
  'pause',
  'pauseAfter',
  'pauseBefore',
  'perspective',
  'perspectiveOrigin',
  'pitch',
  'pitchRange',
  'placeContent',
  'placeItems',
  'placeSelf',
  'playDuring',
  'position',
  'quotes',
  'regionFragment',
  'resize',
  'richness',
  'right',
  'rowGap',
  'rubyAlign',
  'rubyMerge',
  'rubyPosition',
  'running',
  'scrollBehavior',
  'scrollMargin',
  'scrollMarginBlock',
  'scrollMarginBlockEnd',
  'scrollMarginBlockStart',
  'scrollMarginBottom',
  'scrollMarginInline',
  'scrollMarginInlineEnd',
  'scrollMarginInlineStart',
  'scrollMarginLeft',
  'scrollMarginRight',
  'scrollMarginTop',
  'scrollPadding',
  'scrollPaddingBlock',
  'scrollPaddingBlockEnd',
  'scrollPaddingBlockStart',
  'scrollPaddingBottom',
  'scrollPaddingInline',
  'scrollPaddingInlineEnd',
  'scrollPaddingInlineStart',
  'scrollPaddingLeft',
  'scrollPaddingRight',
  'scrollPaddingTop',
  'scrollSnapAlign',
  'scrollSnapStop',
  'scrollSnapType',
  'shapeImageThreshold',
  'shapeInside',
  'shapeMargin',
  'shapeOutside',
  'speak',
  'speakHeader',
  'speakNumeral',
  'speakPunctuation',
  'speechRate',
  'stress',
  'stringSet',
  'tabSize',
  'tableLayout',
  'textAlign',
  'textAlignAll',
  'textAlignLast',
  'textCombineUpright',
  'textDecoration',
  'textDecorationColor',
  'textDecorationLine',
  'textDecorationStyle',
  'textEmphasis',
  'textEmphasisColor',
  'textEmphasisPosition',
  'textEmphasisStyle',
  'textGroupAlign',
  'textHeight',
  'textIndent',
  'textJustify',
  'textOrientation',
  'textOverflow',
  'textShadow',
  'textSpaceCollapse',
  'textSpaceTrim',
  'textSpacing',
  'textTransform',
  'textUnderlinePosition',
  'textWrap',
  'top',
  'transform',
  'transformBox',
  'transformOrigin',
  'transformStyle',
  'transition',
  'transitionDelay',
  'transitionDuration',
  'transitionProperty',
  'transitionTimingFunction',
  'unicodeBidi',
  'userSelect',
  'verticalAlign',
  'visibility',
  'voiceFamily',
  'volume',
  'whiteSpace',
  'widows',
  'width',
  'willChange',
  'wordBreak',
  'wordSpacing',
  'wordWrap',
  'wrapAfter',
  'wrapBefore',
  'wrapFlow',
  'wrapInside',
  'wrapThrough',
  'writingMode',
  'zIndex'
]
